/**
 * Единая paywall-модалка (docs/billing/ui.md §2): «показываем фичу, по клику —
 * предупреждение и тарифы». Монтируется один раз в App, открывается через
 * `usePaywallStore` — из UI-гейтов и из перехвата серверного 403 в `lib/api.ts`.
 */
import { useNavigate } from 'react-router';
import { IconSparkles } from '@tabler/icons-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { usePaywallStore } from '@/stores/paywallStore';
import { billingSettingsUrl } from './billingSettingsUrl';
import { paywallCopy } from './paywallTexts';

export function PaywallModal() {
  const reason = usePaywallStore((s) => s.reason);
  const requiredPlan = usePaywallStore((s) => s.requiredPlan);
  const workspaceId = usePaywallStore((s) => s.workspaceId);
  const close = usePaywallStore((s) => s.close);
  const navigate = useNavigate();

  if (!reason) {
    return null;
  }
  const copy = paywallCopy(reason, requiredPlan);

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) close();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <div className="mb-1 flex size-10 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <IconSparkles className="size-5" />
          </div>
          <DialogTitle className="text-lg">{copy.title}</DialogTitle>
          <DialogDescription>{copy.body}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={close}>
            {copy.secondary}
          </Button>
          <Button
            onClick={() => {
              close();
              void navigate(billingSettingsUrl(workspaceId));
            }}
          >
            {copy.cta}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
